// src/api/axios/interceptors.ts
import { AxiosInstance } from 'axios';
import { toast } from 'sonner';

import { STORAGE, storage } from '@/lib/storage';
import ROUTER from '@/routerMap/ROUTER';
import axios from 'axios';
export const setupInterceptors = (instance: AxiosInstance) => {
  // Request Interceptor
  instance.interceptors.request.use(
    config => {
      // ✅ Lấy token thật đã được lưu sau login
      const token = storage.getLocalStorage(STORAGE.TOKEN);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
      }

      if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
        config.headers['Content-Type'] = 'multipart/form-data';
      }
      return config;
    },
    error => Promise.reject(error),
  );
  // Response Interceptor
  instance.interceptors.response.use(
    response => {
      if (response.config.responseType === 'blob') {
        return response;
      }

      const { errorCode, errorMessage, isError } = response.data;

      if (isError && errorCode !== '200') {
        // ✅ Nếu lỗi 401 → xử lý logout
        if (errorCode === '401') {
          // toast.error('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.');
          localStorage.removeItem('accessToken');
          storage.clearLocalStorage();
          window.location.href = ROUTER.DANG_NHAP; // Không dùng navigate ở đây
        } else {
          toast.error(`${errorMessage}`);
        }

        return Promise.reject({ errorCode, errorMessage });
      }

      return response.data;
    },

    error => {
      toast.error(error?.message || 'Lỗi không xác định từ server');
      return Promise.reject(error);
    },
  );
};

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_ROOT,
  timeout: 60000,
});

setupInterceptors(instance);

export default instance;
